import React, { Suspense, useState } from "react"
import Layout from "./containers/Layout/Layout"
import SeedChecker from "./containers/SeedChecker/SeedChecker"
import SeedRecover from "./containers/SeedRecover/SeedRecover"
import Tutorial from "./containers/Tutorial/Tutorial"
import Writeup from "./containers/Writeup/Writeup"
import Database from "./containers/Database/Database"
import Usersettings from "./containers/Usersettings/Usersettings"
import SeedLister from "./containers/SeedLister/SeedLister"
import { HashRouter, Route, Routes } from "react-router-dom"
import { useLocalStorage } from "./Utils"
import Auth from "./containers/Usersettings/FlioSync/Auth"
import Profile from "./containers/Profile/Profile"

function App() {
    const [render, setRender] = useState(false)

    const defaultDark = window.matchMedia("(prefers-color-scheme: dark)").matches
    const [theme, setTheme] = useLocalStorage("theme", defaultDark ? "dark" : "light")

    const render_again = () => {
        setRender(prev => !prev)
    }

    const updateTheme = new_theme => {
        document.documentElement.setAttribute("data-theme", new_theme)
    }

    const switchTheme = () => {
        const currenttheme = theme === "light" ? "dark" : "light"
        setTheme(currenttheme)
    }

    updateTheme(theme)

    if (window.location.href.includes("code") && /#\//.test(window.location.href)) {
        window.location.href = window.location.href.replace(/(\/\?code=.*)#(.*)/, "/#$2$1")
    }

    return (
        <div className="App">
            <Suspense fallback="loading">
                <HashRouter basename="/">
                    <Layout key={render} rerender={render} lightTheme={theme === "light"} onSwitch={switchTheme}>
                        <Routes>
                            <Route path="/" element={<SeedChecker rerender={render} theme={theme} />} />
                            <Route path="/auth" element={<Auth />} />
                            <Route path="/database" element={<Database rerender={render} />} />
                            <Route path="/seedrecover" element={<SeedRecover rerender={render} />} />
                            <Route path="/seedlisting" element={<SeedLister rerender={render} />} />
                            <Route path="/tutorial" element={<Tutorial rerender={render} />} />
                            <Route path="/writeup" element={<Writeup rerender={render} />} />
                            <Route path="/profile" element={<Profile rerender={render} />} />
                            <Route
                                path="/settings"
                                element={<Usersettings rerender={render} renderAgain={render_again} />}
                            />
                        </Routes>
                    </Layout>
                </HashRouter>
            </Suspense>
        </div>
    )
}

export default App
